export default __webpack_public_path__ + "static/media/account.bf36c977.svg";